import { HotelSearchSummaryContent } from "@website/accommodation-ui/hotel-search/hotel-search-summary/hotel-search-summary-content/hotel-search-summary-content";
import { useHotelSearchSummary } from "@website/accommodation-ui/hotel-search/hotel-search-summary/hotel-search-summary.hook";
import { HotelSearchSummaryPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-summary/hotel-search-summary.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Component: FC<HotelSearchSummaryPropertiesType> = (properties) => {
  const viewProperties = useHotelSearchSummary(properties);
  return <HotelSearchSummaryContent {...viewProperties} />;
};

export const HotelSearchSummary = memo(Component, deepCompare);
